import React from 'react';
import importImg from '../../assets/images/importImg.svg';

const NoDataIndicator = () => {
    return (
        <tr>
            <td colSpan="100%">
                <p className='no_data_item'>
                  <span className="no_data_content">
                       <img src={importImg} alt="NoOpportunities"/>
                       <span>No Data Available.</span>
                  </span>
                </p>
            </td>
        </tr>
    );
};

export default NoDataIndicator;